import { featuresData } from '@/mocks/homeData';

export default function SectionFeatures() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">平台优势</h2>
          <p className="text-sm text-foreground-500 mt-2">为什么千万观众选择在亚洲影视网免费追剧</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {featuresData.map((feature, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-2xl p-8 text-center transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-16 h-16 mx-auto mb-5 flex items-center justify-center bg-primary-100 text-primary-500 rounded-2xl">
                <i className={`${feature.icon} text-2xl`}></i>
              </div>
              <h3 className="text-lg font-semibold text-foreground-900 mb-3">{feature.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}